import { AppSettings } from '../app.settings';
import { AssignDriverScreenFiltersDataModel } from './assign-driver-screen-filters-data-model';

export class AssignDriverScreenFilterModel {
    screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
    filterData: AssignDriverScreenFiltersDataModel = new AssignDriverScreenFiltersDataModel();

    constructor(options?: {
        screenCode?: String,
        filterData: AssignDriverScreenFiltersDataModel
    }) {
        if (options) {
            this.screenCode = options.screenCode;
            this.filterData = options.filterData;
        }
    }
};
